import '../App.css';
import React from 'react';
import { ActionGroup, Header, Item, Text, Flex, Divider } from '@adobe/react-spectrum';
import Highlighter from './Highlighter';
import ProgressBar from './HighlightProgressBar';
import Instructions from '../Instructions';

function MainToolbar({...properties}) {
    function changeTool(e) {
        var toolArray = Array.from(e);
        properties.setSelectedTool(toolArray[0]);
    }

    return (
        <div className="mainToolbar">
            <Header>
            <Flex direction="row" gap="size-200" height={"size-500"} justifyContent={'left'} >
                {/* Don't show any highlighting stuff if the user cannot highlight anything */}
                {properties.maxWordCount === 0 ?
                    <>
                    <div marginStart="size-100"></div> 
                    <Instructions marginTop='size-50' text={"Read the document for an upcoming test. Once you're done, press the \"Finish Reading\" button on the bottom right corner."}/>
                    </>
                    :
                    <>
                    <ActionGroup marginBottom="size-100" marginStart="size-100" isEmphasized disallowEmptySelection='true' selectionMode="single" defaultSelectedKeys={['highlighter']} onSelectionChange={e => changeTool(e)} >
                        <Item key="highlighter">
                            <Highlighter /> <Text>Highlight</Text>
                        </Item>
                    </ActionGroup>
                    <Divider orientation="vertical" height="size-300" marginTop="size-50" size='M'/>
                    <Instructions marginTop='size-50' text={"Read the document and highlight any text you think is important for an upcoming test. Once you're done, press the \"Finish Reading\" button on the bottom right corner."}/>
                    </>
                }
         
            </Flex>
                  
            <ProgressBar shadowCount={properties.shadowCount} progressCount={properties.progressCount} maxWordCount={properties.maxWordCount} constrainHighlights={properties.constrainHighlights} />
            
            </Header>

        </div>
    );
}

export default MainToolbar;